import { Modal, Button } from 'gatorcomponents';
import React from 'react';
import * as Styles from './ExitConfirmModal.styles';

const ExitConfirmModal = ({
  onCloseModal,
  title,
  description,
  buttonsProps = [],
}) => (
  <Modal onClose={onCloseModal} noHeader testId="exit-confirm-modal">
    <Styles.Wrapper>
      <Styles.Title>{title}</Styles.Title>
      <Styles.Description>{description}</Styles.Description>
      <Styles.ButtonsContainer>
        {buttonsProps.map(button => (
          <Button
            key={button.testId}
            testId={button.testId}
            variant={button.variant}
            label={button.label}
            size={button.size}
            onClick={button.onClick}
          />
        ))}
      </Styles.ButtonsContainer>
    </Styles.Wrapper>
  </Modal>
);

export default ExitConfirmModal;
